(() => {
  function enhance(root) {
    if (root.dataset.enhanced) return;
    root.dataset.enhanced = 'true';
    const body = root.querySelector('[data-page-body]');
    if (!body) return;
    const title = root.querySelector('h1').textContent.trim().toLocaleLowerCase();
    body.querySelectorAll('h1').forEach(node => {
      if (node.textContent.trim().toLocaleLowerCase() === title) node.remove();
      else { const heading = document.createElement('h2'); heading.append(...node.childNodes); node.replaceWith(heading); }
    });
    if (root.dataset.fePage === 'about') {
      [...body.children].forEach(node => {
        if (node.tagName === 'P' && node.children.length === 1 && node.firstElementChild.tagName === 'STRONG' && node.textContent.trim() === node.firstElementChild.textContent.trim()) {
          const heading = document.createElement('h2'); heading.textContent = node.textContent; node.replaceWith(heading);
        }
      });
      const index = root.querySelector('[data-page-index]');
      const links = index.querySelector('[data-index-links]');
      [...body.querySelectorAll('h2')].forEach((heading, i) => {
        heading.id ||= `${root.id || root.closest('[id]')?.id || 'fe-about'}-chapter-${i + 1}`;
        const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = heading.textContent; links.append(link);
      });
      index.hidden = !links.children.length;
    }
    if (root.dataset.fePage !== 'faq') return;
    const headings = [...body.children].filter(node => node.tagName === 'H2');
    if (!headings.length) return;
    headings.forEach(heading => {
      const details = document.createElement('details'); details.className = 'fe-faq-item';
      const summary = document.createElement('summary'); summary.textContent = heading.textContent;
      const answer = document.createElement('div'); answer.className = 'fe-faq-answer';
      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && next.tagName === 'H2')) { const following = next.nextSibling; answer.append(next); next = following; }
      details.append(summary, answer); heading.replaceWith(details);
    });
    const items = [...body.querySelectorAll('.fe-faq-item')];
    const tools = root.querySelector('[data-faq-tools]'); tools.hidden = false;
    const button = tools.querySelector('[data-expand-faq]');
    const updateLabel = () => { const visible = items.filter(item => !item.hidden); button.textContent = visible.length && visible.every(item => item.open) ? button.dataset.collapseLabel : button.dataset.expandLabel; };
    button.addEventListener('click', () => { const visible = items.filter(item => !item.hidden); const open = !visible.every(item => item.open); visible.forEach(item => { item.open = open; }); updateLabel(); });
    items.forEach(item => item.addEventListener('toggle', updateLabel));
    tools.querySelector('[data-faq-search]').addEventListener('input', event => {
      const query = event.target.value.trim().toLocaleLowerCase();
      items.forEach(item => { item.hidden = !item.textContent.toLocaleLowerCase().includes(query); if (query && !item.hidden) item.open = true; });
      tools.querySelector('[data-faq-empty]').hidden = items.some(item => !item.hidden);
      button.hidden = items.every(item => item.hidden); updateLabel();
    });
  }
  const init = () => document.querySelectorAll('[data-fe-page]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  const previewPage = document.querySelector('[data-preview-page][data-preview-title]');
  if (previewPage) {
    const previewTitle = previewPage.dataset.previewTitle;
    document.title = `${previewTitle} – Foot-Easy`;
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.content = document.title;
  }
  document.addEventListener('shopify:section:load', init);
})();

